<template>
  <div class="main">
    <AppHeader />
    <main>
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<script lang="ts" src="./MainLayout.ts"></script>

<style lang="scss" scoped src="./MainLayout.scss"></style>
